/**
 * Date formatting utilities
 */

/**
 * Format date for display (Indonesian locale)
 * @param {string|Date} date - Date to format
 * @returns {string} Formatted date string
 */
export const formatDate = (date) => {
  if (!date) return "";
  return new Date(date).toLocaleDateString("id-ID");
};

export const formatLongDate = (date) => {
  if (!date) return "";

  const tanggalObj = new Date(date);
  if (Number.isNaN(tanggalObj.getTime())) return "";

  const options = {
    day: "numeric",
    month: "long",
    year: "numeric",
  };

  return new Intl.DateTimeFormat("en-US", options).format(tanggalObj);
};

/**
 * Format date for HTML date input (YYYY-MM-DD format)
 * @param {string|Date} date - Date to format
 * @returns {string} Date in YYYY-MM-DD format
 */
export const formatDateForInput = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

/**
 * Mengubah format waktu dari 'HH:MM:SS+TZ' ke 'HH.mm' (format 24 jam).
 * @param {string} timeString - String waktu (misal: "01:00:00+07").
 * @returns {string} Waktu yang diformat (misal: "01.00").
 */
export function formatTime(timeString) {
  if (!timeString) return "";

  const text = String(timeString);
  const jam = text.substring(0, 2);
  const menit = text.substring(3, 5);

  if (!jam || !menit) return "";

  return `${jam}.${menit}`;
}

/**
 * Format date as 'DD MMMM YYYY' in Indonesian
 * @param {string|Date} date - Date to format
 * @returns {string} Formatted date string
 */
export const formatDateLongIndo = (date) => {
  if (!date) return "";
  return new Date(date).toLocaleDateString("id-ID", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};

/**
 * Format date as 'DD/MM/YYYY' with zero-padding
 * @param {string|Date} date - Date to format
 * @returns {string} Formatted date string e.g. '01/03/2026'
 */
export const formatDateShort = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};
